import { jsx as _jsx } from "react/jsx-runtime";
import { classNames } from "../classNames.js";
import { colorClassName, modifier, sizeClassName, } from "../modifiers/index.js";
export const Tag = ({ children, className, color, isLight, isRounded, size, }) => {
    const _class = classNames("tag", colorClassName(color), sizeClassName(size), modifier({ isLight, isRounded }), className);
    return _jsx("span", { className: _class, children: children });
};
